export default {
  yourCart: {
    en: 'Your cart',
  },
  itemsInCart: {
    en: '{count, plural, one {# Item} other {# Items}} in cart',
  },
}
